import React, {PropsWithChildren, ReactNode} from "react";

import {PrimaryBadge} from "@pg-design/badge-module";

import {cardBadgeStyle} from "./CardBadge.module.css";

export const CardBadge = (props: PropsWithChildren) => {
    return <PrimaryBadge className={cardBadgeStyle}>{props.children}</PrimaryBadge>;
};
import React, {PropsWithChildren, ReactNode} from "react";

import {PrimaryBadge} from "@pg-design/badge-module";

import {cardBadgeStyle} from "./CardBadge.module.css";

export const CardBadge = (props: PropsWithChildren) => {
    return <PrimaryBadge className={cardBadgeStyle}>{props.children}</PrimaryBadge>;
};
